// Smaller derivatives of the exact approved catalog portraits. New catalog
// entries fall back to their original PNG until a thumbnail is packaged.
const packaged = new Set([
  'male-1', 'male-2', 'male-3', 'male-4', 'male-5',
  'female-1', 'female-2', 'female-3', 'female-4', 'female-5', 'female-6',
]);

export function catalogThumbnailUrl(modelUrl: string): string | null {
  try {
    const url = new URL(modelUrl);
    if (url.origin !== 'https://lluvykhqgdnbfobjixbj.supabase.co') return null;
    const match = url.pathname.match(/^\/storage\/v1\/object\/public\/avatars\/prerendered\/((?:male|female)-[0-9]+)\.glb$/i);
    return match && packaged.has(match[1]) ? `/avatar-posters/${match[1]}.webp` : null;
  } catch { return null; }
}
